
/**
 * Send a form details to the sendmail.php file.
 */

+function($){

  page.initAutocomplete = function() {


      $('.basicAutoComplete').autoComplete({
          resolver: 'custom',
          events: {
              search: function (qry, callback) {
                  // let's do a custom ajax call
                  $.ajax(
                      site_url+'/services.json',
                      {
                          data: { 'qry': qry}
                      }
                  ).done(function (res) {
                      let services = [];
                      for (let i = 0; i < res['results'].length; i++) {
                          const object = res['results'][i];

                          if (object.text.toLowerCase().indexOf(qry.toLowerCase()) >= 0) {
                              services.push(object);
                          }
                      }
                      callback(services)
                  });
              }
          },
          minLength:0,

      });

      $('.basicAutoComplete').on('autocomplete.select', function (evt, item) {
          evt.preventDefault();
          if(item.url.length > 0) {
              window.location.href = item.url;
          }
      });

      $(document).on('click', '.basicAutoComplete', function(){
          if($(this).val().length == 0) {
              $(this).trigger('keyup');
          }
      });

      $(document).on('click', '.btn.click', function(e) {
          e.preventDefault();
          $(this).closest("form").find(".cta-5-mailer").removeClass("d-none");
      });

        return false;
  }

}(jQuery);

